var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendancePurpleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6648 14.5797C13.6781 14.5797 15.3102 12.9476 15.3102 10.9344C15.3102 8.92112 13.6781 7.28906 11.6648 7.28906C9.65159 7.28906 8.01953 8.92112 8.01953 10.9344C8.01953 12.9476 9.65159 14.5797 11.6648 14.5797Z",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 18.1674C6.36104 17.0869 7.19805 16.1795 8.23075 15.5456C9.26345 14.9117 10.4515 14.5762 11.6632 14.5762C12.8749 14.5762 14.063 14.9117 15.0957 15.5456C16.1284 16.1795 16.9654 17.0869 17.514 18.1674",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2914 10.2067C20.599 12.0342 20.3178 13.9122 19.4884 15.5695C18.659 17.2268 17.3244 18.5776 15.6773 19.4269C14.0301 20.2762 12.1557 20.5801 10.3245 20.2946C8.49344 20.0091 6.80044 19.1491 5.49001 17.8386C4.17958 16.5282 3.31953 14.8352 3.03404 13.0041C2.74855 11.173 3.0524 9.29853 3.90172 7.65137C4.75103 6.00421 6.10186 4.6696 7.75915 3.84024C9.41644 3.01088 11.2944 2.72968 13.122 3.03726",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7676 5.10266L18.2257 6.56078L21.142 3.64453",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendancePurpleIcon);
export default __webpack_public_path__ + "static/media/attendance_purple_icon.ed40b448d3184c4fd8ef0336aa3e1531.svg";
export { ForwardRef as ReactComponent };